import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "@/locales";

Vue.use(VueI18n);

export const SUPPORTED_LOCALES = ["ko", "en", "ja"];

// 부팅 시 임시 로케일: 브라우저 언어 → en. (영속 설정은 user_account.locale에 저장 →
//  로그인 후 App.vue가 setLocale로 적용. 미로그인/미설정이면 이 브라우저 감지값 사용.)
// 지원 언어(ko/en/ja)가 아닌 브라우저(중국어 등)는 en 기본.
function detectLocale() {
  const browser = (navigator.language || "en").split("-")[0];
  return SUPPORTED_LOCALES.includes(browser) ? browser : "en";
}

const i18n = new VueI18n({
  locale: detectLocale(),
  fallbackLocale: "en", // 미지원 로케일·미번역 키는 en으로 폴백 (ko는 소스/최다완성 언어)
  messages,
  silentFallbackWarn: true, // 점진 전환 중 경고 숨김
});

// 언어 변경: i18n 로케일만 갱신(메모리). 영속화는 호출부가 user_account.locale에 저장하고,
// Vuetify 컴포넌트 로케일도 호출부에서 `this.$vuetify.lang.current = lang`로 동기화한다.
export function setLocale(lang) {
  if (!SUPPORTED_LOCALES.includes(lang)) return;
  i18n.locale = lang;
}

export default i18n;
